import { put, call, takeLatest, select } from 'redux-saga/effects';

import { EMPLOYER_ROUTES } from 'consts';
import { updateFinalStory } from 'services/story';
import { AsyncAction } from 'types/Action';
import { Store } from 'types/store/Store';
import {
  UpdateFinalStoryMeta,
  UpdateFinalStoryPayload,
} from 'types/store/UpdateFinalStoryState';

import { updateFinalStoryActions } from '../actions';

function* updateFinalStoryRequest(
  action: AsyncAction<UpdateFinalStoryMeta, UpdateFinalStoryPayload>,
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        updateFinalStory,
        action.meta,
        state.auth.token,
      );
      yield put(updateFinalStoryActions.success(data));
    } catch (e: any) {
      yield put(updateFinalStoryActions.failed(e.message));
    }
  }
}

function* updateFinalStorySuccess(
  action: AsyncAction<UpdateFinalStoryMeta, UpdateFinalStoryPayload>,
) {
  //   yield put(push(EMPLOYER_ROUTES.STORY_EDITOR));
  //   window.location.reload();
}

function* updateFinalStoryWatcher(): any {
  yield takeLatest(updateFinalStoryActions.REQUEST, updateFinalStoryRequest);
  yield takeLatest(updateFinalStoryActions.SUCCESS, updateFinalStorySuccess);
}

export default updateFinalStoryWatcher;
